import { ISearchCatNavBannersRequest } from "@faire/web-api/indigofair/data/ISearchCatNavBannersRequest";
import { PageType } from "@faire/web-api/indigofair/data/PageType";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useCachedBannerResponseStore } from "@faire/retailer/components/Banners/CachedBannerResponseStore";
import { ExploreBanner } from "@faire/retailer/components/Banners/ExploreBanners/ExploreBannerEnum";
import { IBannerData } from "@faire/retailer/lib/bannerUtils";

export const useExplorePageBannersQuery = (productSearchString: string) => {
  const column = useResponsiveValue({
    mobileAndAbove: 2,
    tabletAndAbove: 4,
    desktopAndAbove: 5,
  });
  const request = ISearchCatNavBannersRequest.build({
    query: productSearchString,
    page_type: PageType.EXPLORE_PAGE,
  });

  const { cachedRequest: fetchCategoryPageBanners } =
    useCachedBannerResponseStore(["cachedRequest"]);

  const { data: bannersResponse } = useQuery({
    queryKey: [request],
    queryFn: () => fetchCategoryPageBanners(request),
    enabled: !!productSearchString,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  const bannerDisplayData: IBannerData<ExploreBanner>[] = [];

  const { filter_pill_banner } = bannersResponse ?? {};

  if (filter_pill_banner) {
    bannerDisplayData.push({
      type: ExploreBanner.FILTER_PILL_TILE,
      size: 1,
      row: 2,
      column,
      rowNumberRelativeToProductRow: false,
    });
  }

  return { bannerDisplayData, bannersResponse };
};
